import { FC } from "react";
import { AppRoutes } from "./AppRoutes";

export const App: FC = () => {
	return <AppRoutes />;
};
